import ContinuousReview from 'assets/assetsV1/illustrations/deerIllustrations/continuous_review.svg';
import OnetimeReview from 'assets/assetsV1/illustrations/deerIllustrations/one_time_review.svg';
import RecurringReview from 'assets/assetsV1/illustrations/deerIllustrations/recurring_review.svg';

import { ContinuousReviewTrigger } from './ContinuousReviewTrigger';
import { RecurringReviewTrigger } from './RecurringReviewTrigger';

export const TYPE_OF_REVIEWS = [
  {
    heading: 'One-time review',
    subHeading:
      'A single review for a set group over a defined period—ideal for year-end reviews and skill assessments.',
    imgSrc: OnetimeReview,
    key: 'one-time-review',
  },
  {
    heading: 'Continuous review',
    subHeading:
      'Triggered for employees upon reaching milestones, auto-adding them based on set criteria—perfect for probation and performance improvement.',
    imgSrc: ContinuousReview,
    ConditionComponent: ContinuousReviewTrigger,
    key: 'continuous-review',
  },
  {
    heading: 'Recurring review',
    subHeading:
      'Repeated reviews for the same group at regular intervals—ideal for monthly or quarterly performance check-ins.',
    ConditionComponent: RecurringReviewTrigger,

    imgSrc: RecurringReview,
    key: 'recurring-review',
  },
];
